import * as React from 'react'

const SnapshotDataTable = ({ headers, data, numberOfRows, }) => {
  const headerElements = headers.map(header => (<th aria-label={header} key={header}>{header}</th>))

  const dataRowsForTable = data ? data.slice(0, numberOfRows) : [{}, {}, {}]

  const rowElements = dataRowsForTable.map((row, i) => {
    const { value, count, } = row

    return (
      <tr className="data-row" key={i}>
        <td>{value || '—'}</td>
        <td>{value ? count?.toLocaleString() : '—'}</td>
      </tr>
    )
  })

  return (
    <table className="table">
      <thead>
        <tr className="header-row">
          {headerElements}
        </tr>
      </thead>
      <tbody>
        {rowElements}
      </tbody>
    </table>
  )
}

export default SnapshotDataTable
